import { NAME } from './constants';

export const SET_WEEKS = `${NAME}/SET_WEEKS`;
export const RESET_WEEKS = `${NAME}/RESET_WEEKS`;
export const UPDATE_WEEK_EFFECTIVITY = `${NAME}/UPDATE_WEEK_EFFECTIVITY`;
export const CHANGE_CURVE_TYPE = `${NAME}/CHANGE_CURVE_TYPE`;
export const RESET_STARTUP_CURVE = `${NAME}/RESET_STARTUP_CURVE`;
export const SET_INCORRECT_WEEKS = `${NAME}/SET_INCORRECT_WEEK`;
export const RESET_INCORRECT_WEEKS = `${NAME}/RESET_INCORRECT_WEEKS`;
